import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SetupService } from '../configuracoes/setup/setup.service';
import { UsuarioLogado } from '../seguranca/usuario/usuario-logado.model';
import { UsuarioService } from '../seguranca/usuario/usuario.service';
import { AuthService } from '../shared/auth/auth.service';
import { AppConfig } from '../shared/model/config.model';
import { GlobalsVariablesService } from '../shared/service/global-variables.service';
import { MessageService } from '../shared/service/message.service';
import { TokenStorageService } from '../shared/service/token-storage.service';
import { BrandingService } from '../shared/service/branding.service';
import { LoginLeftPanelComponent } from './login-modern/login-left-panel/login-left-panel.component';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    @ViewChild(LoginLeftPanelComponent) leftPanel: LoginLeftPanelComponent;

    public loginModel: any = { login: '', password: '' };
    private usuarioLogado: UsuarioLogado = new UsuarioLogado();
    public authToken;
    public errors;
    isLoading: boolean = false;

    constructor(
        public _router: Router,
        public _messageService: MessageService,
        public _authService: AuthService,
        public _usuarioService: UsuarioService,
        public globalsVariablesService: GlobalsVariablesService,
        public cookieService: CookieService,
        public _setupService: SetupService,
        public tokenStorageService: TokenStorageService,
        public brandingService: BrandingService
    ) {
        document.querySelector('body').classList.add('backLogin');
    }

    ngOnInit() {
        this.brandingService.applyThemeVariables();
    }

    public logar() {
        if (!this.loginModel.login || !this.loginModel.password) {
            this._messageService.error('Por favor, preencha todos os campos');
            return;
        }

        this.isLoading = true;
        this._authService.authenticate(this.loginModel).subscribe(res => {
            this.authToken = res.mensagem;
            document.querySelector('body').classList.remove('backLogin');

            this._authService.autenticarUsuario(this.loginModel).subscribe(res => {
                this.usuarioLogado = res;
                this.tokenStorageService.setIdUsuario(this.usuarioLogado.id);
                this.tokenStorageService.setUsuarioLogado(this.usuarioLogado);

                if (this.usuarioLogado.pessoaNomeFantasia != '' && this.usuarioLogado.pessoaNomeFantasia != 'undefined') {
                    this._setupService.getSetup().then(setup => {
                        this.globalsVariablesService.setPermissoes(this.usuarioLogado.permissao);
                        this.globalsVariablesService.setGlobalsVariables(this.usuarioLogado);
                        this.globalsVariablesService.setInformacoesSetup(setup);
                        this.globalsVariablesService.setRepresentante();
                        this.cookieService.set('user', JSON.stringify(this.loginModel), 365);
                        this.toggleContentWrapper('250px');
                        this._router.navigate(['/dashboard']);
                        this.tokenStorageService.setPrimeiroAcesso(true);
                        this.isLoading = false;
                    }).catch(err => {
                        console.log("Falha ao carregar o SETUP: ", err);
                        this.globalsVariablesService.setGlobalsVariables(this.usuarioLogado);
                        this.cookieService.set('user', JSON.stringify(this.loginModel), 365);
                        this._router.navigate(['/dashboard']);
                        this.isLoading = false;
                    });
                }
            }, () => {
                this.isLoading = false;
                this._messageService.error('Erro ao autenticar usuário. Por favor tente novamente.');
            });

        }, error => {
            this.isLoading = false;
            this.errors = error;
            this._messageService.error('Usuário ou senha incorretos. Por favor tente novamente.');
        });
    }

    private toggleContentWrapper(margin: string) {
        setTimeout(() => {
            let content = document.querySelector('.container-mr7') as HTMLDivElement;
            if (content) {
                content.style.marginLeft = margin;
            }
        }, 25);
    }
}